export class ForeignFilter  {

    readonly ALL: string = "*";
    readonly CANADA : string = "CA";
    readonly GREAT_BRITAIN_NORTHERN_ISLAND : string = "GB";
    readonly BERMUDA : string = "BM";
    readonly CAYMAN_ISLANDS : string = "KY";

}